import type { WeeklySchedule } from "@fysaro/types";
import { useTranslation } from "react-i18next";

const daysOrder = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const;

export function WeeklyScheduleView({ schedule }: { schedule: WeeklySchedule }) {
  const { t } = useTranslation(["common", "clinic-settings"]);
  if (!schedule) return null;

  return (
    <div className="space-y-3">
      {daysOrder.map((day) => {
        const slots = schedule[day] || [];

        return (
          <div
            key={day}
            className="flex items-center justify-between py-2 border-b border-dashed border-border/50 last:border-0"
          >
            {/* Nombre del dí­a */}
            <span className="text-[10px] font-black uppercase tracking-widest text-muted-foreground w-20">
              {t(`common:day_names.${day.toLowerCase()}`)}
            </span>

            {/* Listado de turnos */}
            <div className="flex flex-wrap gap-2 justify-end flex-1">
              {slots.length > 0 ? (
                slots.map((slot, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-1.5 bg-secondary/30 px-3 py-1.5 rounded-xl border border-border/50 shadow-sm"
                  >
                    <span className="text-[11px] font-black text-foreground/80 font-mono">
                      {slot.start}
                    </span>
                    <span className="text-[10px] opacity-30 font-bold">â†’</span>
                    <span className="text-[11px] font-black text-foreground/80 font-mono">
                      {slot.end}
                    </span>
                  </div>
                ))
              ) : (
                <span className="text-[10px] font-bold uppercase text-muted-foreground/40 italic">
                  {t("clinic-settings:tab_calendar.closed")}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
